@if(!showHeader && showMobileHeader){
<fgb-page-header [pageTitle]="mobileTitle" [showBalance]="showPoints" [backButtonLink]="'/'"></fgb-page-header>
} @if(showHeader && !isMobileNavDisabled){
<fgb-page-header [pageTitle]="mobileTitle" [showBalance]="showPoints" [showQr]="showQrCode" [backButtonLink]="'/'"></fgb-page-header>
<div class="mobile-content-wrapper pt-lg-4" *ngIf="!isMobileNavDisabled">
  <div class="container">
    <fgb-route-nav indicatorStyle="rounded" (onTabChange)="title = $event">
      <a
        class="nav-item"
        [routerLink]="['/rewards/marketplace']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'rewards.nav.marketplace' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
      <a
        class="nav-item"
        [routerLink]="['/rewards/events']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'reward.nav.events' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
      <a
        class="nav-item"
        [routerLink]="['/rewards/raffles']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'reward.nav.raffles' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
      <a
        class="nav-item d-lg-flex d-none"
        [routerLink]="['/rewards/wallet']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'rewards.nav.wallet' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
    </fgb-route-nav>
  </div>
</div>
}
<router-outlet></router-outlet>
